"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.number.constructor");

var _CardInfoV = _interopRequireDefault(require("@/views/dashboard/components/CardInfo/Merchant/CardInfoV0"));

var _BarChart = _interopRequireDefault(require("../components/BarChart"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "merchant-v0",
  components: {
    BarChart: _BarChart.default,
    CardInfo: _CardInfoV.default
  },
  props: {
    data: Object,
    loading: Boolean,
    labels: Array,
    values: Array,
    redirectToDocs: Function,
    tableData: Array,
    numberOfDecimal: Number
  },
  computed: {
    cardInfo: function cardInfo() {
      return [[{
        icon: 'star',
        color: '#ffb900',
        label: this.$t('dashboard.merchant.availableBalance'),
        value: parseFloat(this.data.processAvailableAmount),
        decimal: true,
        // unit: this.$store.getters.dollarSign
        numberOfDecimal: this.numberOfDecimal
      }, {
        icon: 'documentation',
        color: '#36a3f7',
        label: this.$t('dashboard.merchant.frozenAmount'),
        value: parseFloat(this.data.processFrozenAmount),
        decimal: true,
        // unit: this.$store.getters.dollarSign
        numberOfDecimal: this.numberOfDecimal
      }], [{
        icon: 'email',
        color: '#f4516c',
        label: this.$t('dashboard.merchant.uncreditedAmount'),
        value: this.data.processUncreditedAmount,
        decimal: false,
        // unit: this.$t('dashboard.merchant.smsUnit')
        numberOfDecimal: this.numberOfDecimal
      }, {
        icon: 'money',
        color: '#34bfa3',
        label: this.$t('dashboard.merchant.totalRecharge'),
        value: parseFloat(this.data.processAmount),
        decimal: true,
        // unit: this.$store.getters.dollarSign
        numberOfDecimal: this.numberOfDecimal
      }]];
    }
  }
};
exports.default = _default;